import { render } from "./ContactUs.vue?vue&type=template&id=db7e9904"
const script = {}
script.render = render

export default script